import SchoolAvatar from './SchoolAvatar';

export default function StaffRequestCard({ request, onApprove, onDeny, disabled = false }) {
  if (!request) return null;

  return (
    <div className="sat-request-card">
      <div className="sat-request-head">
        <div className="sat-request-person">
          <SchoolAvatar name={request.name} seed={request.seed ?? request.id} large className="sat-request-avatar" />
          <div className="sat-request-person-copy">
            <div className="sat-request-name">{request.name}</div>
            <div className="sat-request-meta">
              <span>{request.schoolName}</span>
              <span>{request.role}</span>
            </div>
            <div className="sat-request-email">{request.email}</div>
            <div className="sat-request-phone">{request.phone}</div>
          </div>
        </div>
      </div>

      <div className="sat-request-actions">
        <button type="button" className="sat-request-btn deny" onClick={() => onDeny?.(request)} disabled={disabled}>
          Reject
        </button>
        <button type="button" className="sat-request-btn approve" onClick={() => onApprove?.(request)} disabled={disabled}>
          {disabled ? 'Working...' : 'Approve'}
        </button>
      </div>
    </div>
  );
}
